import { Model } from "@interfaces/model.interface";

export interface ExternalPackaging extends Model {
	code: string;
	stockLevel: number;
	supplierId?: number;
	trackStock: boolean;
}

export class ExternalPackaging implements ExternalPackaging {	

	constructor(data?: Partial<ExternalPackaging>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}